import React, { useState, useEffect, useRef, useCallback } from "react";
import slide1 from "../assets/slide1.png";
import slide2 from "../assets/slide2.png";
import slide3 from "../assets/slide3.png";
import Newsletter from "./newsLetter";
import TestimonialsSection from "./testimonials";
import { useNavigate } from "react-router-dom";

const defaultSlideData = [
  {
    image: slide1,
    heading: "Join the Movement for Equity",
    text: "Partner with us in promoting for social justice and equality. Together, we can strengthen communities and drive meaningful change through our collective efforts.",
  },
  {
    image: slide2,
    heading: "Building a Just and Equitable Community",
    text: "Join us in our mission to promote social justice and equality by training individuals, strengthening communities, and “Building with community for systemic change",
  },
  {
    image: slide3,
    heading: "Together for a Just Society",
    text: "Be part of a community dedicated to promoting fairness and equality. Engage with us to make a significant impact and help build a more inclusive world.",
  },
];

const HeroSection = () => {
  const [slides, setSlides] = useState(defaultSlideData);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [prevSlide, setPrevSlide] = useState(null);
  const headingRef = useRef(null);
  const textRef = useRef(null);
  const [blogs, setBlogs] = useState([]);
  const [imageUrl, setImageUrl] = useState(null);
  const [loadingImage, setLoadingImage] = useState(true);
  const [taskforces, setTaskforces] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [isClicked, setIsClicked] = useState(false);
  const [eventData, setEventData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);

  // const eventsPerPage = window.innerWidth < 768 ? 1 : 2;
  const [eventsPerPage, setEventsPerPage] = useState(2);

  // const totalPages = Math.ceil(eventData.length / eventsPerPage);
  const getEventsPerPage = () => (window.innerWidth < 768 ? 1 : 2);

  useEffect(() => {
    const updateEventsPerPage = () => {
      const newEventsPerPage = getEventsPerPage();
      setEventsPerPage(newEventsPerPage);
    };

    updateEventsPerPage();

    window.addEventListener("resize", updateEventsPerPage);

    return () => {
      window.removeEventListener("resize", updateEventsPerPage);
    };
  }, []);

  const parseDateString = (dateString) => {
    return new Date(dateString);
  };

  const todayUTC = new Date(
    Date.UTC(
      new Date().getUTCFullYear(),
      new Date().getUTCMonth(),
      new Date().getUTCDate()
    )
  );

  const futureEvents = eventData.filter((event) => {
    const eventDate = parseDateString(event.attributes.date);
    return eventDate >= todayUTC;
  });

  const pastEvents = eventData.filter((event) => {
    const eventDate = parseDateString(event.attributes.date);
    return eventDate < todayUTC;
  });

  futureEvents.sort((a, b) => {
    const dateA = parseDateString(a.attributes.date);
    const dateB = parseDateString(b.attributes.date);
    return dateA - dateB;
  });

  pastEvents.sort((a, b) => {
    const dateA = parseDateString(a.attributes.date);
    const dateB = parseDateString(b.attributes.date);
    return dateB - dateA;
  });

  const allEvents = [...futureEvents, ...pastEvents];

  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const newTotalPages = Math.ceil(allEvents.length / eventsPerPage) || 1;
    setTotalPages(newTotalPages);
  }, [eventsPerPage, allEvents.length]);

  const handlePrev = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const currentEvents = allEvents.slice(
    currentPage * eventsPerPage,
    (currentPage + 1) * eventsPerPage
  );

  const handleViewMoreClick = () => {
    setIsClicked(true);
    setTimeout(() => {
      navigate("/blog");
      window.scrollTo(0, 0);
    }, 300);
  };

  const handleLearnMoreClick = () => {
    setTimeout(() => {
      navigate("/WhatWeDo");
      window.scrollTo(0, 0);
    }, 300);
  };

  const handleClickUpcomingEvent= (id)=>{
    setTimeout(() => {
      navigate(`/events/${id}`);
      window.scrollTo(0, 0);
    }, 300);
  }

  const fetchTaskforces = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/taskforces?populate=*`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        return data.data.slice(0, 3);
      } else {
        console.error("Error fetching taskforces");
        return [];
      }
    } catch (error) {
      console.error("Error fetching taskforces:", error);
      return [];
    }
  };

  const fetchBlogs = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/blogs`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        return data.data.slice(0, 3);
      } else {
        console.error("Error fetching blogs");
        return [];
      }
    } catch (error) {
      console.error("Error fetching blogs:", error);
      return [];
    }
  };

  useEffect(() => {
    const fetchEventData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/events?populate=*`,
          {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
            },
          }
        );
        const data = await response.json();
        setEventData(data.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching event data: ", error);
        setLoading(false);
      }
    };

    fetchEventData();
  }, []);

  const fetchExtraSlides = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/home-slide-shows?populate=*`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        return data.data.map((slides) => {
          return {
            image: slides.attributes.BackgroundImage.data.attributes.url,
            heading: slides.attributes.Title,
            text: slides.attributes.desc,
          };
        });
      } else {
        console.error("Error fetching taskforces");
        return [];
      }
    } catch (error) {
      console.error("Error fetching taskforces:", error);
      return [];
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      const [fetchedTaskforces, fetchedBlogs, fetchedExtraSlides] =
        await Promise.all([
          fetchTaskforces(),
          fetchBlogs(),
          fetchExtraSlides(),
        ]);

      setTaskforces(fetchedTaskforces);
      setBlogs(fetchedBlogs);
      setSlides((prev) => [...prev, ...fetchedExtraSlides]);
      setLoading(false);
    };

    fetchData();
  }, []);

  const fetchImageUrl = useCallback(async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/our-mission?populate=our_mission_pic`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`, // Ensure this token has correct permissions
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch image data.");
      }

      const data = await response.json();

      const imageData =
        data.data.attributes.our_mission_pic.data.attributes.url;

      const fullImageUrl = imageData.startsWith("http")
        ? imageData
        : `${process.env.REACT_APP_BASE_URL}${imageData}`;

      setImageUrl(fullImageUrl);
    } catch (err) {
      console.error("Error fetching image URL:", err);
    } finally {
      setLoadingImage(false);
    }
  }, []);

  useEffect(() => {
    fetchImageUrl();
  }, [fetchImageUrl]);

  useEffect(() => {
    const interval = setInterval(() => {
      setPrevSlide(currentSlide);
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [currentSlide]);

  useEffect(() => {
    const adjustSpacing = () => {
      const headingHeight = headingRef.current
        ? headingRef.current.offsetHeight
        : 0;
      const textHeight = textRef.current ? textRef.current.offsetHeight : 0;
      const totalHeight = headingHeight + textHeight;

      if (totalHeight < 300) {
        headingRef.current.style.marginBottom = "12px";
        textRef.current.style.transform = "translateY(-10px)";
      } else {
        headingRef.current.style.marginBottom = "24px";
        textRef.current.style.transform = "translateY(0)";
      }
    };

    adjustSpacing();
    window.addEventListener("resize", adjustSpacing);
    return () => window.removeEventListener("resize", adjustSpacing);
  }, [currentSlide]);

  const nextSlide = () => {
    setPrevSlide(currentSlide);
    setCurrentSlide((currentSlide + 1) % slides.length);
  };

  const prevSlideFunc = () => {
    setPrevSlide(currentSlide);
    setCurrentSlide((currentSlide - 1 + slides.length) % slides.length);
  };

  const renderTaskforce = (taskforce, index) => {
    const imageUrl =
      taskforce.attributes.title_background?.data?.attributes?.formats?.medium
        ?.url ||
      taskforce.attributes.title_background?.data?.attributes?.formats?.small
        ?.url ||
      taskforce.attributes.title_background?.data?.attributes?.url ||
      null;

    const getCategoryStyle = (category) => {
      switch (category) {
        case "Environment":
          return {
            backgroundColor: "#A1F7CC33",
            textColor: "#0B7B69",
          };
        case "Jobs":
          return {
            backgroundColor: "#C543C51A",
            textColor: "#800080",
          };
        case "Education":
          return {
            backgroundColor: "#FFF2DB",
            textColor: "#FFA500",
          };
        default:
          return {
            backgroundColor: "#f1f1f1",
            textColor: "#000",
          };
      }
    };

    const category =
      taskforce.attributes.taskforce_category?.data?.attributes?.title ||
      "Unknown";
    const categoryStyles = getCategoryStyle(category);

    return (
      <div
        key={taskforce.id}
        className={`flex flex-col w-full sm:w-[calc(50%-15px)] md:w-[calc(33.333%-20px)] mb-5 md:mb-10 ${
          (index + 1) % 3 !== 0 ? "md:mr-5" : ""
        } rounded-[20px] overflow-hidden bg-transparent`}
      >
        <div
          className="w-full h-[200px] sm:h-[270px] rounded-[20px]"
          style={{
            backgroundImage: imageUrl ? `url(${imageUrl})` : "none",
            backgroundColor: imageUrl ? "transparent" : "#f1f1f1",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>

        {/* Content Section */}
        <div className="pt-4 sm:pt-8">
          <h2 className="font-primary text-[20px] sm:text-[24px] font-semibold leading-[1.2] text-[#002A57] mb-2 sm:mb-3">
            {taskforce.attributes.title}
          </h2>
          <p className="font-secondary text-[14px] sm:text-[16px] font-normal leading-[1.5] text-[#433E3F] mb-4 sm:mb-6">
            {taskforce.attributes.description}
          </p>

          {/* Learn More and Category in a Single Line */}
          <div className="flex flex-wrap justify-between items-center mt-2 sm:mt-4">
            {/* Category Tag */}
            <div
              className="px-3 py-1 rounded-full text-center font-primary text-[14px] sm:text-[16px] font-normal leading-[1.8] whitespace-nowrap mb-2 sm:mb-0"
              style={{
                backgroundColor: categoryStyles.backgroundColor,
                color: categoryStyles.textColor,
              }}
            >
              {category}
            </div>

            {/* Learn More Section */}
            <a
              href={`/taskforces/${taskforce.id}`}
              className="flex items-center text-[#FFA500] text-[14px] sm:text-[16px] font-normal leading-[1.5] gap-2"
            >
              <span>Learn More</span>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.3576 16.1876C8.22997 16.4267 8.29961 16.7313 8.5297 16.8945C8.77897 17.0712 9.12262 17.0153 9.29677 16.7697L14.8429 8.9481L15.6949 13.7987L15.7127 13.8714C15.7948 14.1299 16.0581 14.2966 16.3329 14.2529C16.6322 14.2047 16.8326 13.9234 16.78 13.6249L15.6975 7.46339L15.6801 7.3916C15.6434 7.27505 15.5686 7.17496 15.4707 7.10558C15.4123 7.06417 15.3459 7.03403 15.2746 7.0173C15.0566 6.96615 14.8316 7.04999 14.7037 7.23034L8.39364 16.1293L8.3576 16.1876ZM8.44163 8.65677C8.49581 8.95552 8.7818 9.15831 9.08129 9.10855L12.4858 8.5475L12.5586 8.53046C12.8173 8.45112 12.9802 8.19164 12.9305 7.91779C12.9034 7.76841 12.8191 7.64354 12.7041 7.56202C12.5879 7.47962 12.4416 7.44096 12.2909 7.46599L8.88676 8.02646L8.81406 8.04362C8.55582 8.12337 8.39252 8.38331 8.44163 8.65677Z"
                  fill="#FFA500"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    );
  };

  const renderBlog = (blog) => {
    return (
      <div
        key={blog.id}
        className="w-full md:w-[350px] lg:w-[380px] h-auto rounded-[20px] border border-[#E3E3E3] flex flex-col overflow-hidden mb-[20px]"
      >
        <div
          className="w-full h-[231px] rounded-t-[20px]"
          style={{
            backgroundColor: blog.attributes.image?.data
              ? "transparent"
              : "#f1f1f1",
            backgroundImage: blog.attributes.image?.data
              ? `url(${blog.attributes.image.data.attributes.url})`
              : "none",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>

        {/* Content Section */}
        <div className="p-[20px] flex flex-col gap-[10px] flex-grow">
          {/* Author and Date */}
          <div className="flex items-center font-secondary text-[13px] text-custom-orange">
            <span>
              By{" "}
              {blog.attributes.author_name
                ? blog.attributes.author_name
                : "Faith Coalition "}{" "}
              |{" "}
              {new Date(blog.attributes.date_created).toLocaleDateString(
                "en-US",
                {
                  month: "long",
                  day: "numeric",
                  year: "numeric",
                }
              )}
            </span>
          </div>

          {/* Title */}
          <h2 className="font-primary text-[17px] font-semibold leading-[24px] text-custom-blue m-0 capitalize">
            {blog.attributes.title || ""}
          </h2>
        </div>

        {/* Divider */}
        <div className="w-[332px] ml-6 mt-5 border-b border-[#E3E3E3]"></div>

        {/* Read Article Section */}
        <div className="p-5 flex justify-end">
          <a
            href={
              blog.attributes.external
                ? blog.attributes.externalLink
                : `/blogs/${blog.id}`
            }
            target={blog.attributes.external ? "_blank" : "_self"}
            className="flex items-center text-[#FFA500] text-[14px] font-manrope"
          >
            <span>Read Article</span>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginLeft: "5px" }}
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.35731 16.1874C8.22969 16.4265 8.29933 16.7311 8.52942 16.8943C8.77868 17.071 9.12233 17.0151 9.29649 16.7695L14.8426 8.94793L15.6947 13.7986L15.7124 13.8712C15.7945 14.1297 16.0578 14.2965 16.3326 14.2527C16.6319 14.2046 16.8323 13.9232 16.7797 13.6247L15.6972 7.46322L15.6798 7.39143C15.6431 7.27488 15.5683 7.17479 15.4705 7.10541C15.412 7.064 15.3457 7.03386 15.2743 7.01713C15.0563 6.96598 14.8313 7.04981 14.7034 7.23017L8.39335 16.1291L8.35731 16.1874ZM8.44057 8.65675C8.49475 8.9555 8.78074 9.15829 9.08023 9.10853L12.4847 8.54748L12.5576 8.53044C12.8162 8.45109 12.9791 8.19162 12.9294 7.91777C12.9024 7.76839 12.8181 7.64354 12.7031 7.562C12.5869 7.4796 12.4406 7.44094 12.2898 7.46599L8.88569 8.02644L8.813 8.0436C8.55476 8.12335 8.39146 8.38329 8.44057 8.65675Z"
                fill="#FFA500"
              />
            </svg>
          </a>
        </div>
      </div>
    );
  };

  return (
    <>
      <style>
        {`
          .slide {
            position: absolute;
            inset: 0;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center center;
            background-color: black; /* Set background color to avoid white flash */
            opacity: 0;
            transition: opacity 1s ease-in-out;
          }

          .slide.active {
            opacity: 1;
          }

          .slide-text {
            opacity: 0;
            transform: translateY(20px);
            transition: opacity 1s ease-in-out, transform 1s ease-in-out;
          }

          .slide-text.active {
            opacity: 1;
            transform: translateY(0);
          }

          .slide-container {
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            height: 712px;
            overflow: hidden;
            background-color: black; /* Set background color to avoid white flash */
          }

          .heading {
            opacity: 0;
            transform: translateY(20px);
            transition: opacity 1s ease-in-out, transform 1s ease-in-out, margin-bottom 1s ease-in-out;
          }

          .heading.active {
            opacity: 1;
            transform: translateY(0);
          }

          .text {
            opacity: 0;
            transition: opacity 1s ease-in-out, transform 1s ease-in-out;
          }

          .text.active {
            opacity: 1;
          }

          .buttons {
            opacity: 0;
            transform: translateY(20px);
            transition: opacity 1s ease-in-out, transform 1s ease-in-out;
          }

          .buttons.active {
            opacity: 1;
            transform: translateY(0);
          }
        `}
      </style>
      <div id="hero-section" className="w-full">
        <div className="slide-container flex justify-center items-center">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`slide ${
                currentSlide === index ? "active" : ""
              } absolute top-0 left-0 w-full h-full`}
              style={{
                backgroundImage: `url(${slide.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="absolute inset-0 bg-[rgba(10,10,11,0.7)]"></div>
              <div
                className={`absolute slide-text w-full max-w-[1200px] mx-auto ${
                  currentSlide === index ? "active" : ""
                } top-[20%] left-[10px] md:left-[20px] lg:left-[40px] xl:left-[8%] 2xl:left-[26.5%] transform -translate-x-1/2`}
              >
                <div
                  ref={headingRef}
                  className={`heading ${
                    currentSlide === index ? "active" : ""
                  } w-full md:w-[577px] font-primary text-[28px] md:text-[64px] font-bold leading-tight md:leading-[76.8px] text-left text-white mb-4 md:mb-[24px]`}
                >
                  {slide.heading}
                </div>
                <div
                  ref={textRef}
                  className={`text ${
                    currentSlide === index ? "active" : ""
                  } w-full md:w-[577px] font-primary text-[16px] md:text-[18px] font-normal leading-normal md:leading-[25.6px] text-left text-white mb-6 md:mb-[32px]`}
                >
                  {slide.text}
                </div>
                <div className="flex flex-col sm:flex-row sm:space-x-4 space-y-4 sm:space-y-0">
                  <a
                    href="/donate"
                    className="flex items-center justify-center w-[152px] h-[48px] text-[14px] font-medium leading-[18px] text-white bg-custom-blue rounded-[30px] font-primary"
                  >
                    Invest
                  </a>
                  <a
                    href="/volunteer"
                    className="flex items-center justify-center w-[152px] h-[48px] text-[13px] font-medium leading-[18px] text-white border-[0.5px] border-white rounded-[30px] font-secondary"
                  >
                    Join Us
                  </a>
                </div>
              </div>
            </div>
          ))}
          <div className="absolute flex flex-row items-center gap-[8px] top-[543px] right-[120px] bottom-[121px] left-[1203px] hidden md:flex">
            <div
              className={`animate-svg w-12 h-12 flex justify-center items-center rounded-full relative ${
                currentSlide !== 0
                  ? "border-[1.5px] border-white opacity-100"
                  : "border-[1.5px] border-[rgba(255,255,255,0.4)] opacity-40"
              }`}
              onClick={prevSlideFunc}
            >
              <svg
                width="9"
                height="16"
                viewBox="0 0 9 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.71392 15.0748C8.42103 15.3677 7.94616 15.3677 7.65326 15.0748L1.10781 8.52931C0.814916 8.23642 0.814916 7.76154 1.10781 7.46865L7.65326 0.923194C7.94616 0.630301 8.42103 0.630301 8.71392 0.923194C9.00682 1.21609 9.00682 1.69096 8.71392 1.98385L2.6988 7.99898L8.71392 14.0141C9.00682 14.307 9.00682 14.7819 8.71392 15.0748Z"
                  fill="white"
                />
              </svg>
            </div>
            <div
              className={`animate-svg w-12 h-12 flex justify-center items-center rounded-full relative ${
                currentSlide !== slides.length - 1
                  ? "border-[1.5px] border-white opacity-100"
                  : "border-[1.5px] border-[rgba(255,255,255,0.4)] opacity-40"
              }`}
              onClick={nextSlide}
            >
              <svg
                width="9"
                height="15"
                viewBox="0 0 9 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.286076 0.239689C0.578969 -0.0532038 1.05384 -0.0532038 1.34674 0.239689L7.89219 6.78514C8.18508 7.07804 8.18508 7.55291 7.89219 7.8458L1.34674 14.3913C1.05384 14.6842 0.578969 14.6842 0.286076 14.3913C-0.00681706 14.0984 -0.00681706 13.6235 0.286076 13.3306L6.3012 7.31547L0.286076 1.30035C-0.00681706 1.00746 -0.00681706 0.532583 0.286076 0.239689Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>
        </div>

        <div className="flex justify-center items-center md:mt-[30px]">
          <div className="flex flex-col md:flex-row w-full xl:w-[1200px] h-auto">
            <InfoBox
              backgroundColor="rgba(241, 174, 69, 1)"
              title="Racial Equity"
              description="We work to eliminate racial disparities and promote equal opportunities for all community members"
              icon={
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M35.1707 34.8669H27.2047V10.191H37.3168C36.1226 12.1788 33.0804 17.6067 33.0804 21.3643C33.0804 24.4178 35.5238 26.902 38.5238 26.902C41.5249 26.902 43.9671 24.4178 43.9671 21.3643C43.9671 17.8259 40.8885 12.2067 39.7159 10.191H43.3328V7.85702H27.2049V3H21.7636V7.85702H5.6366V10.191H9.23641C8.04161 12.1788 5 17.6067 5 21.3643C5 24.4178 7.44199 26.902 10.4432 26.902C13.4455 26.902 15.8863 24.4178 15.8863 21.3643C15.8863 17.8259 12.8083 12.2067 11.6333 10.191H21.7621V34.8669H13.7962V38.558H5.63544V44H43.3315V38.558H35.1707V34.8669ZM42.1384 20.49H34.9089C35.2822 17.5206 37.3646 13.5883 38.5134 11.6119C39.6508 13.6294 41.7422 17.6475 42.1384 20.49ZM14.0576 20.49H6.82812C7.20199 17.5206 9.28437 13.586 10.4331 11.6119C11.5727 13.6294 13.6637 17.6464 14.0576 20.49Z"
                    fill="#FAFAFA"
                  />
                </svg>
              }
            />
            <InfoBox
              backgroundColor="rgba(227, 105, 84, 1)"
              title="Civic Engagement"
              description="We foster civic participation to ensure every voice is heard and valued"
              icon={
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_1510_761)">
                    <path
                      d="M0 30.8491H6.41858V45.9949H0V30.8491Z"
                      fill="#FAFAFA"
                    />
                    <path
                      d="M32.0858 24.0181H23.8047L24.0321 25.9894H31.679L32.0858 24.0181Z"
                      fill="#FAFAFA"
                    />
                    <path
                      d="M33.6591 28.8018H21.5261L20.9812 24.0732L15.3577 26.8857C13.2219 28.1697 11.5139 28.8018 11.1151 30.8492H9.23828V45.995H10.7782L16.6281 48H33.6591C34.9844 48 36.0588 46.9255 36.0588 45.6002C36.0588 44.2749 34.9844 43.2004 33.6591 43.2004C34.9844 43.2004 36.0588 42.1263 36.0588 40.8007C36.0588 39.4753 34.9844 38.4009 33.6591 38.4009C34.9844 38.4009 36.0588 37.3268 36.0588 36.0015C36.0588 34.6761 34.9844 33.6013 33.6591 33.6013C34.9844 33.6013 36.0588 32.5272 36.0588 31.2019C36.0588 29.8762 34.9844 28.8018 33.6591 28.8018Z"
                      fill="#FAFAFA"
                    />
                    <path
                      d="M24.9199 7.67773V21.1715L32.699 21.0957V7.60156L24.9199 7.67773Z"
                      fill="#FAFAFA"
                    />
                    <path
                      d="M47.9373 0L45.135 0.00585938L45.1401 2.32617L35.5 6.99207V21.594L45.1914 26.1075L45.1969 28.6227L47.9991 28.6168L47.9373 0Z"
                      fill="#FAFAFA"
                    />
                    <path
                      d="M21.6598 7.70947C17.9398 7.74133 14.9391 10.7937 14.971 14.5137C14.9863 16.3154 15.7026 18.0037 16.9877 19.2671C18.2588 20.5166 19.9357 21.2025 21.7173 21.2025C21.7371 21.2025 21.7568 21.2025 21.7766 21.2021L22.1172 21.1989V7.70508L21.6598 7.70947Z"
                      fill="#FAFAFA"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1510_761">
                      <rect width="48" height="48" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              }
            />
            <InfoBox
              backgroundColor="rgba(0, 86, 179, 1)"
              title="Fair Economy"
              description="We organize individuals for fair policies and practices to create sustainable communities"
              icon={
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.7725 36.6343C16.7496 36.8626 16.7693 37.101 16.8525 37.3373C17.0557 37.9069 17.5325 38.3709 18.0973 38.5458C18.6221 38.7117 19.1443 38.6013 19.3027 38.429L20.3976 37.2541C20.7144 36.9154 20.7944 36.3741 20.6083 35.8487C20.1501 34.9709 19.5363 34.6541 18.7501 34.5122L16.7725 36.6343Z"
                    fill="#FAFAFA"
                  />
                  <path
                    d="M15.3082 30.7593L13.3946 32.8116C13.0058 33.2345 12.8944 33.8847 13.1114 34.5076C13.3418 35.1657 13.8917 35.7012 14.5498 35.9012C15.1728 36.0879 15.7978 35.9428 16.1893 35.5263L17.961 33.626C18.3525 33.2041 18.4613 32.5572 18.2442 31.9343C18.0138 31.2729 17.4608 30.7396 16.8058 30.5407C16.2832 30.3737 15.6698 30.3673 15.3082 30.7593Z"
                    fill="#FAFAFA"
                  />
                  <path
                    d="M11.5143 27.3825L9.74733 29.2795C9.35799 29.6993 9.24919 30.3515 9.46413 30.9766C9.69453 31.6326 10.2444 32.1681 10.9025 32.3681C11.5244 32.5574 12.1559 32.4097 12.3527 32.2011L14.3143 30.0961C14.7057 29.6731 14.8145 29.023 14.5975 28.4011C14.366 27.7409 13.8161 27.2075 13.158 27.0097C12.5527 26.8123 11.8828 26.9878 11.5143 27.3825Z"
                    fill="#FAFAFA"
                  />
                  <path
                    d="M8.05873 23.6426L6.10033 25.7488C5.70886 26.1706 5.60006 26.8176 5.81713 27.4373C6.04539 28.1008 6.59846 28.6341 7.25659 28.8341C7.87846 29.0197 8.50886 28.8757 8.70353 28.6645L10.6673 26.5594V26.5573C11.0587 26.1408 11.1675 25.4928 10.9505 24.8709C10.7233 24.2074 10.1702 23.6741 9.51206 23.4762C9.00913 23.3029 8.40059 23.273 8.05873 23.6426Z"
                    fill="#FAFAFA"
                  />
                  <path
                    d="M33.4824 11.082C32.2157 11.7903 30.4552 11.9172 28.7405 12.0404C27.4435 12.129 26.1053 12.2228 25.1437 12.578L19.7971 14.5508C19.7608 14.5652 19.724 14.5738 19.6856 14.5791C19.4275 14.6196 19.1885 14.6543 18.9741 14.6842C17.6723 14.8676 17.5219 14.9236 17.372 15.3092C17.2355 15.6655 17.3853 16.1791 17.7555 16.6154C18.0573 16.9738 19.2387 18.0927 21.6691 17.5172L24.7139 17.1151C26.4189 16.8954 27.7859 18.0068 28.8776 18.9039L37.0659 25.4543L37.0723 25.4511C38.6909 24.7738 40.3773 23.8927 41.811 22.1658L33.4824 11.082Z"
                    fill="#FAFAFA"
                  />
                  <path
                    d="M22.2153 10.6844C21.73 10.7292 21.1737 10.7905 20.5902 10.8513C17.363 11.1959 15.5737 11.3313 14.6633 11.1628L6.28516 22.0679C6.59342 22.3596 6.84889 22.6625 7.05476 22.9905C7.75502 22.2737 8.81316 22.0177 9.84356 22.3292C10.8548 22.6343 11.699 23.454 12.0521 24.4711C12.202 24.9015 12.2489 25.3431 12.2105 25.766C12.6238 25.7079 13.0606 25.7319 13.4905 25.8631C14.499 26.166 15.3465 26.9879 15.6969 28.0049C15.8489 28.4332 15.8969 28.8737 15.8606 29.2967C16.274 29.2385 16.7108 29.2631 17.1406 29.3969C18.147 29.702 18.9908 30.5217 19.3438 31.5335C19.5657 32.1751 19.5742 32.8353 19.394 33.4273C19.4969 33.4471 19.6025 33.4721 19.7076 33.5052C20.6105 33.7852 21.3774 34.5271 21.7076 35.4417C22.0222 36.3271 21.8857 37.2572 21.3689 37.9249L22.8553 39.1137C23.219 39.4023 23.7492 39.4337 24.2441 39.1937C24.7806 38.9335 25.186 38.4049 25.3054 37.8135C25.3556 37.5665 25.339 37.3271 25.2825 37.1052L23.3972 35.5969C23.1438 35.3937 23.099 35.0188 23.2969 34.7585C23.4969 34.5004 23.8638 34.4524 24.1188 34.6556L26.3854 36.4721C26.6105 36.6524 27.2553 36.7004 27.8468 36.422C28.4686 36.1249 28.9385 35.5127 29.0686 34.8295C29.1934 34.1836 28.9934 33.5575 28.5486 33.1991L26.4985 31.5585C26.243 31.3553 26.1982 30.9793 26.3982 30.7223C26.5961 30.4609 26.9652 30.4129 27.218 30.6193L30.1982 33.0028C30.6462 33.3591 31.29 33.4081 31.8846 33.1308C32.5012 32.8359 32.971 32.2247 33.1044 31.534C33.2292 30.8881 33.0292 30.2641 32.5796 29.9025L29.5982 27.5223C29.3428 27.3169 29.298 26.942 29.498 26.6796C29.698 26.4225 30.0649 26.3777 30.3209 26.5804C30.3209 26.5804 34.8478 30.2001 34.851 30.2001C35.0761 30.3772 35.7177 30.4273 36.3065 30.1457C36.9294 29.8551 37.3961 29.2439 37.5316 28.5553C37.6542 27.9084 37.4542 27.2801 37.0068 26.9249L28.1465 19.8343C27.13 19.0007 26.0798 18.1372 24.8601 18.3009L21.8766 18.6903C19.8654 19.1735 17.9684 18.6956 16.8713 17.3985C16.21 16.6172 15.9849 15.6508 16.282 14.8737C16.6985 13.7959 17.4964 13.6844 18.8132 13.4988C19.01 13.4737 19.2217 13.4428 19.4548 13.406L24.7465 11.454C25.0905 11.326 25.4713 11.2375 25.8654 11.1591C24.5049 10.6327 23.5188 10.6012 22.2153 10.6844Z"
                    fill="#FAFAFA"
                  />
                  <path
                    d="M10.7164 8.61779C9.75262 8.54472 8.87262 9.27112 7.60595 10.9207L4.36648 15.1405C3.19475 16.6626 2.75582 17.6093 2.85288 18.4114C2.93075 19.0706 3.38942 19.7175 3.84435 20.0823L5.38088 21.3095L13.7249 10.4493L12.6449 9.58472C11.9025 8.99272 11.2945 8.66259 10.7164 8.61779Z"
                    fill="#FAFAFA"
                  />
                  <path
                    d="M37.4729 8.6066C36.8947 8.64287 36.2814 8.96607 35.5331 9.54954L34.4414 10.3965L42.6697 21.3453L43.7331 20.5181C44.6531 19.8045 45.1225 19.1661 45.2083 18.5074C45.3145 17.7074 44.8894 16.7533 43.7363 15.2114L40.5497 10.9511C39.3081 9.28447 38.4393 8.54473 37.4729 8.6066Z"
                    fill="#FAFAFA"
                  />
                </svg>
              }
            />
          </div>
        </div>
      </div>
      <div className="w-full h-auto py-[50px] px-4 lg:px-[120px] gap-[10px] bg-white flex justify-center items-center mx-auto">
        <div className="w-full md:w-[1200px] h-auto lg:h-[440px] gap-[47px] flex flex-col lg:flex-row overflow-hidden">
          <div className="w-full lg:w-[585px] h-auto lg:h-[340px] gap-[24px] flex flex-col">
            <div className="flex items-center mb-[24px]">
              <div className="w-[72px] h-0 border-t-2 border-t-custom-orange flex-shrink-0"></div>
              <div className="font-primary text-[16px] font-bold leading-[21.86px] tracking-[2px] text-custom-orange whitespace-nowrap ml-[16px]">
                OUR MISSION
              </div>
            </div>

            <div>
              <div className="w-full md:w-[534px] h-auto font-primary text-[28px] md:text-[42px] font-bold leading-tight md:leading-[50.4px] text-custom-blue mb-[24px]">
                Collaborative Efforts for Racial Equity and Civic Engagement
              </div>
              <div className="w-full md:w-[585px] h-auto font-secondary text-[16px] font-normal leading-normal md:leading-[25.6px] text-custom-lightgray">
                We are a coalition of faith communities, community
                organizations, and individuals working together to promote
                racial equity, civic engagement, a fair economy, and
                participatory decision-making.
              </div>
            </div>

            <div
              className="flex items-center cursor-pointer mt-4 "
              onClick={handleLearnMoreClick}
            >
              <div className="w-auto h-[18px] font-primary text-[16px] font-medium leading-[18px] text-center text-custom-orange">
                Learn More
              </div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.35731 16.1874C8.22969 16.4265 8.29933 16.7311 8.52942 16.8943C8.77868 17.071 9.12233 17.0151 9.29649 16.7695L14.8426 8.94793L15.6947 13.7986L15.7124 13.8712C15.7945 14.1297 16.0578 14.2965 16.3326 14.2527C16.6319 14.2046 16.8323 13.9232 16.7797 13.6247L15.6972 7.46322L15.6798 7.39143C15.6431 7.27488 15.5683 7.17479 15.4705 7.10541C15.412 7.064 15.3457 7.03386 15.2743 7.01713C15.0563 6.96598 14.8313 7.04981 14.7034 7.23017L8.39335 16.1291L8.35731 16.1874ZM8.44057 8.65675C8.49475 8.9555 8.78074 9.15829 9.08023 9.10853L12.4847 8.54748L12.5576 8.53044C12.8162 8.45109 12.9791 8.19162 12.9294 7.91777C12.9024 7.76839 12.8181 7.64354 12.7031 7.562C12.5869 7.4796 12.4406 7.44094 12.2898 7.46599L8.88569 8.02644L8.813 8.0436C8.55476 8.12335 8.39146 8.38329 8.44057 8.65675Z"
                  fill="#FFA500"
                />
              </svg>
            </div>
          </div>
          {loadingImage ? (
            <div className="w-full lg:w-[568px] h-[240px] md:h-[568px] lg:h-[440px] rounded-lg bg-[#e0e0e0] mt-8 md:mt-0 animate-pulse" />
          ) : (
            <img
              src={imageUrl}
              className="lg:w-[568px] h-[240px] md:h-[568px] lg:h-[440px] rounded-lg w-full mt-8 lg:mt-0"
              alt="our mission picture"
            />
          )}
        </div>
      </div>

      <div className="w-full max-w-[1440px] pt-[50px] mx-auto">
        <div className="w-full max-w-[1200px] mx-auto flex justify-between items-center mb-[32px] px-4 lg:px-0">
          <div>
            <div className="flex items-center mb-[16px]">
              <div className="w-[72px] h-0 border-t-[2px] border-[#FFA500] mr-[24px]"></div>
              <div>
                <h4 className="text-[16px] font-semibold leading-[21.86px] tracking-[2px] text-[#FFA500]">
                  EVENTS
                </h4>
              </div>
            </div>

            <div>
              <h2 className="text-[32px] font-semibold leading-[38.4px] text-[#002A57]">
                Upcoming Events
              </h2>
            </div>
          </div>

          <div className="flex gap-[8px]">
            <svg
              onClick={handlePrev}
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{
                cursor: currentPage === 0 ? "not-allowed" : "pointer",
                opacity: currentPage === 0 ? 0.5 : 1,
              }}
            >
              <rect
                width="36"
                height="36"
                rx="18"
                fill={currentPage === 0 ? "#BDC3C7" : "#002A57"}
              />
              <g clipPath="url(#clip0_704_3422)">
                <g clipPath="url(#clip1_704_3422)">
                  <path
                    d="M15.9744 12.9419L10.916 18.0002L15.9744 23.0586"
                    stroke="white"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M25.0836 18H11.0586"
                    stroke="white"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
              </g>
              <defs>
                <clipPath id="clip0_704_3422">
                  <rect
                    width="20"
                    height="20"
                    fill="white"
                    transform="translate(8 8)"
                  />
                </clipPath>
                <clipPath id="clip1_704_3422">
                  <rect
                    width="20"
                    height="20"
                    fill="white"
                    transform="translate(8 8)"
                  />
                </clipPath>
              </defs>
            </svg>

            <svg
              onClick={handleNext}
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{
                cursor:
                  currentPage === totalPages - 1 ? "not-allowed" : "pointer",
                opacity: currentPage === totalPages - 1 ? 0.5 : 1,
              }}
            >
              <rect
                width="36"
                height="36"
                rx="18"
                fill={currentPage === totalPages - 1 ? "#BDC3C7" : "#002A57"}
              />
              <g clipPath="url(#clip0_704_3428)">
                <g clipPath="url(#clip1_704_3428)">
                  <path
                    d="M20.0234 12.9419L25.0817 18.0002L20.0234 23.0586"
                    stroke="white"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M10.916 18H24.941"
                    stroke="white"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
              </g>
              <defs>
                <clipPath id="clip0_704_3428">
                  <rect
                    width="20"
                    height="20"
                    fill="white"
                    transform="translate(8 8)"
                  />
                </clipPath>
                <clipPath id="clip1_704_3428">
                  <rect
                    width="20"
                    height="20"
                    fill="white"
                    transform="translate(8 8)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>

        <div className="w-full max-w-[1200px] h-auto mx-auto flex gap-[30px] flex-wrap px-4 lg:px-0 justify-center md:justify-between">
          {loading ? (
            <p>Loading events...</p>
          ) : (
            currentEvents.map((event, index) => {
              const { title, date } = event.attributes;
              const eventDate = parseDateString(date);

              const day = eventDate.getUTCDate();
              const month = eventDate.toLocaleString("en-US", {
                month: "short",
                timeZone: "UTC",
              });

              const isUpcoming = eventDate >= todayUTC;

              return (
                <div
                  key={index}
                  onClick={()=> handleClickUpcomingEvent(event.id)}
                  className="w-full md:w-[585px] h-auto md:h-[183px] cursor-pointer p-[24px] md:p-[48px] bg-[#F2C94C] rounded-[20px] flex gap-[20px] md:gap-[30px] mb-[30px] overflow-hidden"
                >
                  <div className="w-[47px] h-auto">
                    <p className="text-[48px] font-small leading-[57.6px] text-[#0A0A0B]">
                      {day}
                    </p>
                    <p className="text-[16px] font-small leading-[21.86px] tracking-[2px] text-[#0A0A0B] uppercase">
                      {month}
                    </p>
                  </div>

                  <div className="flex-1 h-auto">
                    {isUpcoming ? (
                      <div className="flex items-center mb-[8px]">
                        <p className="text-[16px] font-small leading-[21.86px] tracking-[2px] text-[#0A0A0B] mr-[8px]">
                          NEW EVENT
                        </p>
                        <div className="w-[44px] h-[0px] border-t-[2px] border-[#1D2130]"></div>
                      </div>
                    ) : (
                      <div className="flex items-center mb-[8px]">
                        <p className="text-[16px] font-small leading-[21.86px] tracking-[2px] text-[#0A0A0B] mr-[8px]">
                          EVENT COMPLETED
                        </p>
                        <div className="w-[44px] h-[0px] border-t-[2px] border-[#1D2130]"></div>
                      </div>
                    )}
                    <h3 className="text-[28px] font-small leading-[42px] text-[#0A0A0B] break-words">
                      {title}
                    </h3>
                  </div>

                  <div className="ml-auto flex items-center justify-center">
                    <svg

                      width="56"
                      height="56"
                      viewBox="0 0 56 56"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="28" cy="28" r="28" fill="white" />
                      <path
                        d="M37.4571 28.7071C37.8476 28.3166 37.8476 27.6834 37.4571 27.2929L31.0931 20.9289C30.7026 20.5384 30.0695 20.5384 29.6789 20.9289C29.2884 21.3195 29.2884 21.9526 29.6789 22.3431L35.3358 28L29.6789 33.6569C29.2884 34.0474 29.2884 34.6805 29.6789 35.0711C30.0695 35.4616 30.7026 35.4616 31.0931 35.0711L37.4571 28.7071ZM19.25 29L36.75 29L36.75 27L19.25 27L19.25 29Z"
                        fill="#1D2130"
                      />
                    </svg>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>

      <div>
        <div className="w-full max-w-[1200px] mx-auto py-[50px] px-4 lg:px-0">
          {/* Taskforces Heading with Strip */}
          <div className="mb-[30px]">
            <div className="flex items-center mb-[20px]">
              <div className="w-[72px] h-0 border-t-2 border-t-custom-orange"></div>

              <div className="pl-[24px] font-primary text-[16px] font-bold leading-[21.86px] tracking-[2px] text-custom-orange mr-[24px]">
                WHAT WE DO
              </div>
            </div>

            {/* Taskforces Heading */}
            <div className="font-primary text-[32px] font-bold leading-[38.4px] text-left text-custom-blue">
              Taskforces
            </div>
          </div>

          {/* Taskforce Cards */}
          <div className="flex flex-wrap justify-between">
            {loading ? (
              <p>Loading taskforces...</p>
            ) : taskforces.length > 0 ? (
              taskforces.map((taskforce, index) =>
                renderTaskforce(taskforce, index)
              )
            ) : (
              <p>No taskforces available.</p>
            )}
          </div>
        </div>
      </div>
      <TestimonialsSection />

      <div className="w-full max-w-[1200px] mx-auto py-[50px] px-4 lg:px-0">
        {/* BLOGS Heading with Strip */}
        <div className="flex items-center mb-5">
          <div className="w-[72px] border-t-2 border-[#FFA500]"></div>
          <div className="pl-6 font-primary text-[16px] font-semibold leading-[21.86px] tracking-[2px] text-[#FFA500]">
            BLOGS
          </div>
        </div>

        {/* News & Articles Heading */}
        <div className="w-full md:w-[534px] h-auto font-primary text-[32px] font-semibold leading-[38.4px] text-left text-[#002A57] mb-7">
          News & Articles
        </div>

        {/* Blogs Grid */}
        <div className="w-full flex flex-wrap gap-[30px]">
          {loading ? (
            <div className="flex w-full justify-center items-center text-custom-blue">
              <svg
                className="animate-spin h-5 w-5 mr-3 border-t-2 border-b-2 border-custom-orange rounded-full"
                viewBox="0 0 24 24"
              ></svg>
              Loading blogs...
            </div>
          ) : blogs.length > 0 ? (
            blogs.map((blog) => renderBlog(blog))
          ) : (
            <p>No blogs available.</p>
          )}
        </div>

        {/* View More Button */}
        <div className="w-full flex justify-end mt-8">
          <div
            className={`w-[152px] h-[48px] py-4 gap-2 rounded-full bg-[#002A57] flex justify-center items-center cursor-pointer transition-all duration-300 ease-in-out ${
              isClicked ? "opacity-70 scale-105" : "opacity-100 scale-100"
            }`}
            onClick={handleViewMoreClick}
          >
            <span className="w-[120px] h-[16px] font-primary text-[13px] font-medium leading-[18px] text-center text-white">
              View More
            </span>
          </div>
        </div>
      </div>

      <Newsletter />
    </>
  );
};

const InfoBox = ({ backgroundColor, title, description, icon }) => (
  <div
    className="relative group w-full md:w-[400px] h-[248px]"
    style={{ backgroundColor }}
  >
    <div className="absolute bottom-0 left-0 px-7 mb-[-10px] w-full h-full flex flex-col justify-end items-start overflow-hidden">
      <div className="transform transition-all duration-500 ease-in-out group-hover:-translate-y-10">
        {icon}
        <div
          className="mb-1 w-[230px] h-[29px] font-primary text-[24px] font-semibold leading-[28.8px] text-left text-white opacity-100"
          style={{ paddingTop: "7px", paddingBottom: "40px" }}
        >
          {title}
        </div>
        <div className="font-secondary text-sm text-white transition-all duration-500 ease-in-out opacity-0 group-hover:opacity-100 mt-2">
          {description}
        </div>
      </div>
    </div>
  </div>
);

export default HeroSection;
